module.exports = __webpack_public_path__ + "img/customers_icon_pink.57a0a815.svg";